import React from 'react';
import Navbar from './Navbar';
import { Toaster } from './ui/sonner';

export default function Layout({ children }) {
  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-gray-100">
        {children}
      </main>
      <Toaster position="top-center" richColors />
    </>
  );
}